export enum FamilyMemberRole {
  PRIMARY_PARENT = 'PRIMARY_PARENT',
  SECONDARY_PARENT = 'SECONDARY_PARENT',
  GRANDFATHER = 'GRANDFATHER',
  GRANDMOTHER = 'GRANDMOTHER',
  GUARDIAN = 'GUARDIAN',
  STUDENT = 'STUDENT',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export enum PlatformRole {
  USER = 'USER',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export enum InvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REVOKED = 'REVOKED',
  EXPIRED = 'EXPIRED',
}

export enum MemberStatus {
  ACTIVE = 'ACTIVE',
  REMOVED = 'REMOVED',
  INVITED = 'INVITED',
}

export enum OtpChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum OtpPurpose {
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  VERIFY_PHONE = 'VERIFY_PHONE',
  RESET_PASSWORD = 'RESET_PASSWORD',
}

export enum AuthProviderType {
  LOCAL = 'LOCAL',
  GOOGLE = 'GOOGLE',
}

export enum GradeLevel {
  LKG = 'LKG',
  UKG = 'UKG',
  GRADE_1 = 'GRADE_1',
  GRADE_2 = 'GRADE_2',
  GRADE_3 = 'GRADE_3',
  GRADE_4 = 'GRADE_4',
  GRADE_5 = 'GRADE_5',
  GRADE_6 = 'GRADE_6',
  GRADE_7 = 'GRADE_7',
  GRADE_8 = 'GRADE_8',
  GRADE_9 = 'GRADE_9',
  GRADE_10 = 'GRADE_10',
}

export enum BoardCode {
  CBSE = 'CBSE',
  ICSE = 'ICSE',
  KARNATAKA = 'KARNATAKA',
}

export enum SubjectCode {
  ENGLISH_GRAMMAR = 'ENGLISH_GRAMMAR',
  ENGLISH_LITERATURE = 'ENGLISH_LITERATURE',
  MATHEMATICS = 'MATHEMATICS',
  EVS = 'EVS',
  KANNADA = 'KANNADA',
  HINDI = 'HINDI',
  IT = 'IT',
}

export enum OnboardingStep {
  FAMILY = 'FAMILY',
  PRIMARY_PARENT = 'PRIMARY_PARENT',
  INVITE_MEMBERS = 'INVITE_MEMBERS',
  ADD_STUDENT = 'ADD_STUDENT',
  ACADEMIC_DETAILS = 'ACADEMIC_DETAILS',
  UPLOAD_CONTENT = 'UPLOAD_CONTENT',
  LEARNING_ASSESSMENT = 'LEARNING_ASSESSMENT',
  COMPLETED = 'COMPLETED',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

export const PARENT_ROLES: FamilyMemberRole[] = [
  FamilyMemberRole.PRIMARY_PARENT,
  FamilyMemberRole.SECONDARY_PARENT,
];

export const GRANDPARENT_ROLES: FamilyMemberRole[] = [
  FamilyMemberRole.GRANDFATHER,
  FamilyMemberRole.GRANDMOTHER,
];

export const ADULT_ROLES: FamilyMemberRole[] = [
  ...PARENT_ROLES,
  ...GRANDPARENT_ROLES,
  FamilyMemberRole.GUARDIAN,
];

export const GRADE_LABELS: Record<GradeLevel, string> = {
  [GradeLevel.LKG]: 'LKG',
  [GradeLevel.UKG]: 'UKG',
  [GradeLevel.GRADE_1]: 'Grade 1',
  [GradeLevel.GRADE_2]: 'Grade 2',
  [GradeLevel.GRADE_3]: 'Grade 3',
  [GradeLevel.GRADE_4]: 'Grade 4',
  [GradeLevel.GRADE_5]: 'Grade 5',
  [GradeLevel.GRADE_6]: 'Grade 6',
  [GradeLevel.GRADE_7]: 'Grade 7',
  [GradeLevel.GRADE_8]: 'Grade 8',
  [GradeLevel.GRADE_9]: 'Grade 9',
  [GradeLevel.GRADE_10]: 'Grade 10',
};

export const SUBJECT_LABELS: Record<SubjectCode, string> = {
  [SubjectCode.ENGLISH_GRAMMAR]: 'English Grammar',
  [SubjectCode.ENGLISH_LITERATURE]: 'English Literature',
  [SubjectCode.MATHEMATICS]: 'Mathematics',
  [SubjectCode.EVS]: 'EVS',
  [SubjectCode.KANNADA]: 'Kannada',
  [SubjectCode.HINDI]: 'Hindi',
  [SubjectCode.IT]: 'IT',
};

export const BRAND = {
  name: 'Tattva',
  tagline: 'Understand. Think. Grow.',
  vision: 'Discover the Essence of Learning.',
  colors: {
    primary: '#2C2A6E',
    secondary: '#E68A2E',
    accent: '#2F9E6F',
    background: '#F8F7F4',
  },
} as const;
